// ESLint
/* eslint no-unused-labels: "off", complexity: "off" */
/* globals TweenMax: true, TimelineMax: true, YT: true, Draggable: true, platformCheck: true, site: true, hashHelper: true, Spinner: true, elementScrollProgress: true */

/* Attempts to create a generic boutique that can be used between multiple projects */
/*
Data:
generic-boutique
generic-boutique-sections
generic-boutique-platform-data
Events:
generic-boutique-init
generic-preload-complete
generic-load-animation-complete
*/
(function ($) {
  'use strict';

  Drupal.behaviors.GenericBoutiqueV1 = {
    /* eslint-disable no-unused-vars */
    attach: function (context, settings) {
    /* eslint-enable no-unused-vars */
      // DOM
      var $boutique = $('.boutique', context);
      var $window = $(window);
      var $sections = $boutique.find('section');
      // LOGIC
      var platformVars = platformCheck({
        target: $boutique[0],
        mobileSize: 767,
        mobileClass: 'mobile',
        desktopClass: 'desktop',
        ipadClass: 'ipad',
        ieClass: 'ie',
        isMobileCallback: function () {
          return typeof site !== 'undefined' ? site.client.isMobile : (/iphone|ipod|android|blackberry|mini|windows\sce|palm/i).test(navigator.userAgent.toLowerCase());
        }
      });
      // Export this!
      var genericBoutique = {
        addSection: function ($newSections) {
          $sections = $sections.add($newSections);
          $boutique.data('generic-boutique-sections', $sections);
        },
        removeSection: function ($targetSections) {
          if ($sections.is($targetSections)) {
            $sections = $sections.not($targetSections);
            $boutique.data('generic-boutique-sections', $sections);
          }
        },
        platformVars: platformVars
      };

      $boutique.data('generic-boutique', genericBoutique);

      // ////////////////////////////////////////////////////////////////////////////////////
      // //////////// BEGIN: Global Functionality
      // ////////////////////////////////////////////////////////////////////////////////////
      (function () {
        // BEGIN: Init
        init: {
          // Update hash as sections gain or lose active
          $sections.on('gainedActive', function () {
            // If boutique is marked to deeplink do not update hash
            if ($boutique.hasClass('js-deeplinking')) {
              return;
            }

            hashHelper.set($(this).attr('id'));
          });

          // Init el product
          $boutique.elproduct({
            target: '[data-product]',
            debug: false,
            map: {
              'INVENTORY_STATUS': [
                {
                  selector: '.el-product_shop-now',
                  targets: ['html'],
                  modifier: function (inventoryStatus) {
                    var inventoryStatusLookup = {
                      3: 'Preorder',
                      5: 'Sold Out',
                      7: 'Sold Out'
                    };

                    return inventoryStatusLookup[inventoryStatus];
                  }
                },
                {
                  selector: '[data-product], .el-product_shop-now',
                  targets: ['data-available'],
                  modifier: function (inventoryStatus) {
                    if (inventoryStatus === 3 || inventoryStatus === 7) {
                      return 'false';
                    }

                    return 'true';
                  }
                }
              ]
            },
            onSuccess: function () {
              $('[data-product], .el-product_shop-now').on('click', function (e) {
                // DOM
                var $this = $(this);
                // LOGIC
                var productData = $this.data('productData');

                // If none of the conditions are met, pass through to normal link behavior
                if ($this.hasClass('quickshop')) {
                  e.preventDefault();

                  // Item must be available for purchase
                  if ($this.attr('data-available') !== 'undefined' && $this.attr('data-available') === 'false') {
                    return;
                  }

                  site.quickshop(productData);
                } else if ($this.hasClass('add-to-bag')) {
                  e.preventDefault();

                  // Item must be available for purchase
                  if ($this.attr('data-available') !== 'undefined' && $this.attr('data-available') === 'false') {
                    return;
                  }

                  site.addToCart({
                    skuData: {
                      SKU_BASE_ID: productData.defaultSku.SKU_ID.substr(3),
                      PARENT_CAT_ID: productData.PRODUCT_ID
                    },
                    quantity: 1,
                    QTY: 1
                  });
                }
              });
            }
          });

          // Expose as data values for external scripts
          $boutique.data('generic-boutique-sections', $sections);
          $boutique.data('generic-boutique-platform-data', platformVars);
        }
        // END: Init

        // BEGIN: Events
        events: {
          $window
            .on('platformcheck-update', function (e) {
              // LOGIC
              var flag = e.originalEvent.detail.flag;

              // Desktop mobile width detection
              if (platformVars.isDesktop && (flag & platformCheck.FLAG_MOBILE)) {
                if ($boutique.hasClass('mobile')) {
                  $boutique.removeClass('mobile');
                  $window.trigger('desktopLostMobile');
                } else {
                  $boutique.addClass('mobile');
                  $window.trigger('desktopGainedMobile');
                }
              }

              if (platformVars.isIpad && (flag & platformCheck.FLAG_ORIENTATION)) {
                if (platformVars.orientation) {
                  $boutique.addClass('ipad-portrait');
                } else if (platformVars.orientation === false) {
                  $boutique.removeClass('ipad-portrait');
                }

                $window.trigger('orientationChanged');
              }
            })
            .on('generic-boutique-scroll scroll', _.debounce(function () {
              // DOM
              var $targets = $sections.not(':hidden');
              var $activeSections;
              // LOGIC
              var id;

              // Set active elements
              elementScrollProgress($targets.toArray(), {
                activeClass: 'active',
                visibleClass: 'visible',
                eventGainVisible: 'gainedVisible',
                eventGainCurrent: 'gainedActive',
                offset: {
                  bottom: function () {
                    return -$('.page-footer .page-sticky-footer__inner').height();
                  }
                }
              });

              // Set deeplink hash
              $activeSections = $sections.filter('.active');

              if ($activeSections.length !== 0) {
                id = $activeSections.first().attr('id');

                if (typeof id !== 'undefined') {
                  hashHelper.set(id.replace('section_', ''));
                }
              }
            }));
        }
        // END: Events
      })();
      // ////////////////////////////////////////////////////////////////////////////////////
      // //////////// END: Global Functionality
      // ////////////////////////////////////////////////////////////////////////////////////

      // ////////////////////////////////////////////////////////////////////////////////////
      // //////////// BEGIN: Carousel Sections
      // ////////////////////////////////////////////////////////////////////////////////////
      (function () {
        // LOGIC
        var carouselSettings = {
          increment: '100%',
          offset: '0%',
          ignoreTargets: '.ignore',
          debug: false,
          useGSAP: false,
          duration: 1,
          callbackAnimation: function () {
            // DOM
            var $newSlide;
            var $otherSlides;
            // LOGIC
            var _this = this;
            var animation = new TimelineMax();

            $newSlide = _this.slides[0];
            $otherSlides = $newSlide.siblings();

            $newSlide.trigger('slideWillGainActive');
            $otherSlides.trigger('slideWillLoseActive'); // Signal that the last slide will lose active after animation

            animation
              .to($otherSlides, 0.5, {
                opacity: 0,
                display: 'none',
                position: 'absolute',
                className: '-=active'
              })
              .to($newSlide, 0.5, {
                opacity: 1,
                display: 'block',
                position: 'relative',
                className: '+=active'
              }, '0')
              .add(function () {
                $newSlide.trigger('slideHasGainedActive');
                _this.$target.trigger('carousel_updated', $newSlide.index());
              });
          }
        };

        // BEGIN: Init
        init: {
          $sections.each(function () {
            // DOM
            var $this = $(this);
            var $carousel = $this.find('.carousel');

            // Must have a carousel for carousel functionality to exist
            if ($carousel.length === 0 || $carousel.find('.slide').length <= 1 || $carousel.hasClass('mpp-grid')) {
              return;
            }

            // Create animation per slide
            $carousel.find('.slide').each(function () {
              // DOM
              var $this = $(this);
              // LOGIC
              var animation = new TimelineMax({ paused: true });

              animation
                .staggerFromTo($this.find('.tile-description').find(
                  'h3' + (platformVars.isMobile ? '.mobile' : '.desktop') + ',' +
              'h2' + (platformVars.isMobile ? '.mobile' : '.desktop') + ',' +
              (platformVars.isMobile ? '.mobile' : '.desktop') + ' > p,' +
              'div.mobile,' +
              '.el-product_shop-now-container'
                ), 0.5, {
                  opacity: 0,
                  y: '20%'
                }, {
                  opacity: 1,
                  y: '0%'
                }, 0.25)
                .addCallback(function () {
                  $this.removeData('animation');
                })
                .addPause();

              $this.data('animation', animation);
            });

            $carousel.elCarousel(carouselSettings);
          });
        }
        // END: Init

        // BEGIN: Events
        events: {
          $window.on('keydown', function (e) {
            // DOM
            var $activeCarousel = $sections.filter('.active').find('.carousel');

            if ($activeCarousel.length === 0) {
              return;
            }

            switch (e.which) {
              case 37:
                $activeCarousel.elCarouselNext();
                break;

              case 39:
                $activeCarousel.elCarouselPrev();
                break;
            }
          });

          $sections.find('li.previous, li.next').on('click', function (e) {
            // DOM
            var $this = $(this);
            var $carousel = $this.closest('section').find('.carousel');

            e.preventDefault();

            if ($carousel.length === 0) {
              return;
            }

            if ($this.hasClass('previous')) {
              $carousel.elCarouselPrev();
            } else if ($this.hasClass('next')) {
              $carousel.elCarouselNext();
            }
          });

          // Play slide animation if available
          $sections.find('.carousel').find('.slide').on('slideHasGainedActive', function () {
            // DOM
            var $this = $(this);
            // LOGIC
            var animation = $this.data('animation');

            if (typeof animation === 'undefined') {
              return;
            }
            animation.play(0);
          });
        }
        // END: Events
      })();
      // ////////////////////////////////////////////////////////////////////////////////////
      // //////////// END: Carousel Sections
      // ////////////////////////////////////////////////////////////////////////////////////

      // ////////////////////////////////////////////////////////////////////////////////////
      // //////////// BEGIN: Video Modal Handling
      // ////////////////////////////////////////////////////////////////////////////////////
      (function () {
        // DOM
        var $videoModal = $boutique.find('.video_container');
        var $volumeKnob = $videoModal.find('.volume-slider .circle');
        var $volumeButton = $videoModal.find('.volume_btn');
        // LOGIC
        var volumeControlFadeout;
        var volumeSlider;
        var videoVars = {
          youtubeAPIReady: false,
          scrubberUpdateTimer: undefined,
          volumeSlider: undefined,
          volumeControlFadeout: undefined,
          player: undefined
        };

        /**
        * @function youtubeUpdateHandler
        * @description Updates the scrubber as the youtube video progresses
        * @returns {undefined}
        */
        function youtubeUpdateHandler() {
          var duration;
          var currentTime;
          var progress;

          if (typeof videoVars.player === 'undefined' || typeof videoVars.player.getDuration !== 'function') {
            return;
          }

          duration = videoVars.player.getDuration();
          currentTime = videoVars.player.getCurrentTime();
          progress = currentTime / duration;

          $videoModal.find('.inner_scrubber').css('width', (progress * 100) + '%');
        }

        /**
        * @function hideVolumeSlider
        * @description Hides the volume slider
        * @returns {undefined}
        */
        function hideVolumeSlider() {
          if (volumeControlFadeout !== 'undefined') {
            clearTimeout(volumeControlFadeout);
          }

          volumeControlFadeout = setTimeout(function () {
            TweenMax.to($videoModal.find('.volume_btn .volume-slider'), 0.5, {
              opacity: 0,
              display: 'none',
              clearProps: 'all',
              onComplete: function () {
                $videoModal.find('.volume_btn').removeClass('active');
              }
            });

            if (typeof volumeControlFadeout !== 'undefined') {
              clearTimeout(volumeControlFadeout);
            }

            volumeControlFadeout = undefined;
          }, 5000);
        }

        /**
        * @function updateVolumeIcon
        * @description Update the volume icon
        * @param {number} volume Volume value between 0 to 100
        * @returns {undefined}
        */
        function updateVolumeIcon(volume) {
          // Reset
          $volumeButton.removeClass('vol-0 vol-1 vol-2 vol-3');

          if (volume === 0) {
            $volumeButton.addClass('vol-0');
          } else if (volume <= 33) {
            $volumeButton.addClass('vol-1');
          } else if (volume <= 66) {
            $volumeButton.addClass('vol-2');
          } else if (volume > 66) {
            $volumeButton.addClass('vol-3');
          }
        }

        // BEGIN: Init
        init: {
          volumeSlider = Draggable.create($volumeKnob, {
            bounds: $volumeKnob.parent(),
            type: 'top',
            onDrag: function () {
              // LOGIC
              var progress = 1 - Math.abs(this.y / this.maxY);

              if (typeof videoVars.player !== 'undefined') {
                videoVars.player.unMute();
                videoVars.player.setVolume(progress * 100);
                updateVolumeIcon(videoVars.player.getVolume());
              } else {
                $videoModal.find('video')[0].muted = false;
                $videoModal.find('video')[0].volume = progress;
                updateVolumeIcon(progress * 100);
              }

              hideVolumeSlider();
            }
          })[0];

          // Set up Youtube
          (function () {
            // DOM
            var tag = document.createElement('script');
            var firstScriptTag = document.getElementsByTagName('script')[0];

            window.onYouTubeIframeAPIReady = function () {
              // DOM
              videoVars.youtubeAPIReady = true;

              $window.trigger('youtubeready');
            };

            tag.src = 'https://www.youtube.com/iframe_api';
            firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
          })();

          // NOTE: Mute disables a ton USE AT OWN RISK
          if (platformVars.isMobile) {
            $videoModal.find('video')[0].muted = false;
            updateVolumeIcon(0);
          }
        }
        // END: Init

        // BEGIN: Events
        events: {
          // Open youtube modal then play youtube video via API
          $boutique.find('[data-youtube-id]:not([data-youtube-id=""]), [data-video-url-mp4]:not([data-video-url-mp4=""]), [data-video-url-webm]:not([data-video-url-webm=""])').on('click', function (e) {
            // DOM
            var $this = $(this);
            var $videoTag = $videoModal.find('video');
            var $videoYoutube = $videoModal.find('.video');
            // LOGIC
            var videoID = $this.data('youtube-id');
            var videoURLMP4 = $this.data('video-url-mp4');
            var videoURLWEBM = $this.data('video-url-webm');
            var isVideoSet = false;

            e.preventDefault();
            e.stopPropagation();
            $window.trigger('videomodalopened');

            // Must have a youtube ID otherwise attempt to play normal video
            if (typeof videoID !== 'undefined' && videoID.trim().length !== 0) {
              $videoTag.css({ display: 'none' });
              $videoYoutube.css({ display: 'block' });

              TweenMax.fromTo($videoModal, 0.5, {
                opacity: 0,
                display: 'none'
              }, {
                opacity: 1,
                display: 'block',
                className: '+=active'
              });

              videoVars.player = new YT.Player($videoYoutube[0], {
                height: '360',
                width: '640',
                videoId: videoID,
                playerVars: {
                  autoplay: 0, // Autoplay is handled via on ready
                  rel: 0,
                  showinfo: 1,
                  iv_load_policy: 3,
                  modestbranding: 1,
                  controls: 0,
                  start: 1,
                  playsinline: 1,
                  enablejsapi: 1,
                  html5: 1
                },
                events: {
                  // Mute needed for mobile autoplay
                  onReady: function () {
                    if (!platformVars.isDesktop && platformVars.isMobile) {
                      videoVars.player.mute();
                      updateVolumeIcon(0);
                    }
                    videoVars.player.playVideo();
                  },
                  onStateChange: function (e) {
                    var state = e.data;

                    // Unstarted/Play/Buffering
                    // Reveal video
                    if (state === -1 || state === 1 || state === 3) {
                      videoVars.scrubberUpdateTimer = window.setInterval(youtubeUpdateHandler, 500);
                      $videoModal.find('.play_btn').addClass('active');
                      // Ended
                      // Hide video
                    } else if (state === 0) {
                      $videoModal.find('.close_btn').trigger('click');
                      $videoModal.find('.play_btn').removeClass('active');
                    } else {
                      $videoModal.find('.play_btn').removeClass('active');
                    }
                  }
                }
              });
            } else {
              $videoTag.css({ display: 'block' });
              $videoYoutube.css({ display: 'none' });
              // Clear URLS
              $videoTag.find('source').attr('src', '');

              if (/\.(mp4){1}$/gi.test(videoURLMP4)) {
                $videoTag.find('source[type="video/mp4"]').attr('src', videoURLMP4);
                isVideoSet = true;
              }

              if (/\.(webm){1}$/gi.test(videoURLWEBM)) {
                $videoTag.find('source[type="video/webm"]').attr('src', videoURLWEBM);
                isVideoSet = true;
              }

              // Attempt to load everything
              $videoTag[0].load();

              if (isVideoSet) {
                $videoTag.one('canplay', function () {
                  this.play();
                });

                TweenMax.fromTo($videoModal, 0.5, {
                  opacity: 0,
                  display: 'none'
                }, {
                  opacity: 1,
                  display: 'block',
                  className: '+=active'
                });
              }
            }
          })
          // Allow links out to function normally
            .find('.explore-more').on('click', function (e) {
              e.stopPropagation();
            });

          // Video play button click
          $videoModal.find('.play_btn').on('click', function (e) {
            // DOM
            var $this = $(this);
            var $video = $videoModal.find('video');

            e.preventDefault();

            // Clear existing video update timers
            if (typeof videoVars.scrubberUpdateTimer !== 'undefined') {
              clearInterval(videoVars.scrubberUpdateTimer);
            }

            videoVars.scrubberUpdateTimer = setInterval(youtubeUpdateHandler, 500);

            if (typeof videoVars.player !== 'undefined') {
              if ($this.hasClass('active')) {
                videoVars.player.pauseVideo();
                $this.removeClass('active');
              } else {
                videoVars.player.playVideo();
                $this.addClass('active');
              }
            } else {
              if ($this.hasClass('active')) {
                $video[0].pause();
                $this.removeClass('active');
              } else {
                $video[0].play();
                $this.add('active');
              }
            }
          });

          $videoModal.find('.volume_btn').on('click', function (e) {
            // DOM
            var $this = $(this);

            e.preventDefault();

            // Mobile toggles volume
            if (platformVars.isMobile) {
              if ($volumeButton.hasClass('vol-0')) {
                if (typeof videoVars.player !== 'undefined') {
                  videoVars.player.unMute();
                  videoVars.player.setVolume(100);
                } else {
                  $videoModal.find('video')[0].muted = false;
                  $videoModal.find('video')[0].volume = 1;
                }
                updateVolumeIcon(100);
              } else {
                if (typeof videoVars.player !== 'undefined') {
                  videoVars.player.mute();
                  videoVars.player.setVolume(0);
                } else {
                  $videoModal.find('video')[0].muted = true;
                  $videoModal.find('video')[0].volume = 0;
                }
                updateVolumeIcon(0);
              }

              return;
            }

            if ($this.hasClass('active')) {
              $this.removeClass('active');
            } else {
              $this.addClass('active');

              hideVolumeSlider();
            }
          });

          // Volume slider click handling
          $videoModal.find('.volume_btn .line-container').on('click', function (e) {
            // DOM
            var $this = $(this);
            var $volumeKnob = $this.find('.circle');
            // LOGIC
            var progress = ($this.offset().top - $window.scrollTop() - e.clientY) / $this.height();

            e.preventDefault();
            e.stopPropagation();

            TweenMax.set($volumeKnob, { top: volumeSlider.maxY * progress });

            if (typeof videoVars.player !== 'undefined') {
              videoVars.player.unMute();
              videoVars.player.setVolume(progress * 100);
              updateVolumeIcon(videoVars.player.getVolume());
            } else {
              $videoModal.find('video')[0].muted = false;
              $videoModal.find('video')[0].volume = progress;
              updateVolumeIcon(progress * 100);
            }

            volumeSlider.update(true);
            volumeSlider.startDrag(e);
            volumeSlider.endDrag(e);

            hideVolumeSlider();
          });

          // Video scrubber click
          $videoModal.find('.scrubber-container').on('click', function (e) {
            // DOM
            var $this = $(this);
            var $video = $videoModal.find('video');
            // LOGIC
            var position = e.clientX - $this.offset().left;
            var duration;
            var progress = position / $this.width();

            e.preventDefault();

            $videoModal.find('.inner_scrubber').css('width', (progress * 100) + '%');

            if (typeof videoVars.player !== 'undefined' && typeof videoVars.player.getDuration === 'function') {
              duration = videoVars.player.getDuration();
              videoVars.player.seekTo(duration * progress);
            } else {
              $video[0].currentTime = $video[0].duration * progress;
            }
          });

          // Video fullscreen click
          $videoModal.find('.full_btn').on('click', function (e) {
            // DOM
            var $player;
            var $video = $videoModal.find('video');
            // LOGIC
            var requestFullScreen;

            e.preventDefault();

            // Must have an available player to do stuff
            if (typeof videoVars.player !== 'undefined') {
              $player = $videoModal.find('iframe');
              if ($player.length === 0) {
                return;
              }
              requestFullScreen = $player[0].requestFullScreen || $player[0].mozRequestFullScreen || $player[0].webkitRequestFullScreen;
              requestFullScreen.call($player[0]);
            } else {
              requestFullScreen = $video[0].requestFullScreen || $video[0].mozRequestFullScreen || $video[0].webkitRequestFullScreen;
              requestFullScreen.call($video[0]);
            }
          });

          // Video close button click
          $videoModal.find('.close_btn').on('click', function (e) {
            // DOM
            var $video = $videoModal.find('video');

            e.preventDefault();
            e.stopPropagation();

            // Clear existing video update timers
            if (videoVars.scrubberUpdateTimer !== 'undefined') {
              window.clearInterval(videoVars.scrubberUpdateTimer);
            }

            if (typeof videoVars.player !== 'undefined') {
              videoVars.player.destroy();
              videoVars.player = undefined;
            } else {
              $video[0].pause();
              $video[0].currentTime = 0;
            }

            TweenMax.to($videoModal, 0.5, {
              opacity: 0,
              display: 'none',
              className: '-=active'
            });

            $window.trigger('videomodalclosed');
          });

          $videoModal.find('video')
            .on('timeupdate', function () {
              var duration;
              var currentTime;
              var progress;

              duration = this.duration;
              currentTime = this.currentTime;
              progress = currentTime / duration;

              $videoModal.find('.inner_scrubber').css('width', (progress * 100) + '%');
            })
            .on('ended', function () {
              $videoModal.find('.close_btn').trigger('click');

              if (platformVars.isMobile) {
                if (typeof this.webkitExitFullScreen === 'function') {
                  this.webkitExitFullScreen();
                }
              }
            })
            .on('play playing', function () {
              $videoModal.find('.play_btn').addClass('active');
            })
            .on('pause', function () {
              $videoModal.find('.play_btn').removeClass('active');
            });
        }
        // END: Events
      })();
      // END: Video Model Handling

      // BEGIN: Inline Video Handling
      (function () {
        // DOM
        var $inlineVideo = $boutique.find('.mp4-container video');

        // BEGIN: Events
        events: {
          $window
            .on('videomodalopened', function () {
              // Pause all inline videos
              $inlineVideo.each(function () {
                this.pause();
              });
            })
            .on('videomodalclosed generic-preload-complete', function () {
              // Pause all inline videos
              $inlineVideo.each(function () {
                this.play();
              });

              $boutique.addClass('loaded');
            });
        }
        // END: Events
      })();
      // ////////////////////////////////////////////////////////////////////////////////////
      // //////////// END: Inline Video Handling
      // ////////////////////////////////////////////////////////////////////////////////////

      // ////////////////////////////////////////////////////////////////////////////////////
      // //////////// BEGIN: Preload Functionality
      // ////////////////////////////////////////////////////////////////////////////////////
      (function () {
        // DOM
        var $loader = $('#loader', $boutique);
        var $deeplinkSection;
        var $targetImages;
        // LOGIC
        var deeplinkData = hashHelper.get();
        var spinnerOptions = {
          lines: 17, // The number of lines to draw
          length: 0, // The length of each line
          width: 5, // The line thickness
          radius: 26, // The radius of the inner circle
          scale: 1, // Scales overall size of the spinner
          corners: 1, // Corner roundness (0..1)
          color: '#000000', // #rgb or #rrggbb or array of colors
          opacity: 0.5, // Opacity of the lines
          rotate: 0, // The rotation offset
          direction: 1, // 1: clockwise, -1: counterclockwise
          speed: 1, // Rounds per second
          trail: 30, // Afterglow percentage
          zIndex: 2e9, // The z-index (defaults to 2000000000)
          className: 'spinner', // The CSS class to assign to the spinner
          top: '50%', // Top position relative to parent
          left: '50%', // Left position relative to parent
          shadow: false, // Whether to render a shadow
          hwaccel: true, // Whether to use hardware acceleration
          position: 'absolute' // Element positioning
        };
        var spinner = new Spinner(spinnerOptions).spin($loader[0]);

        // Default to first section in page
        if (deeplinkData.length === 0) {
          $deeplinkSection = $boutique.find('section').first();
        } else {
          // Attempt to find section without '#section-'
          $deeplinkSection = $boutique.find('#' + deeplinkData[0]);

          if ($deeplinkSection.length === 0) {
            // Attempt to find section with '#section-'
            $deeplinkSection = $boutique.find('#section-' + deeplinkData[0]);

            // Default to first section
            if ($deeplinkSection.length === 0) {
              $deeplinkSection = $boutique.find('section').first();
            }
          }
        }

        // Get all images before the target section images as well, as content may be sized to loaded images
        $targetImages = $deeplinkSection.add($deeplinkSection.prevAll()).find('img');
        $targetImages.FreeLoader({
          callback: function () {
            // LOGIC
            var loadAnimation = new TimelineMax({ delay: 1 });

            // Mark boutique as loaded
            $boutique.addClass('loaded');

            //  Load other (boutique) images normally
            $boutique.find('img').each(function () {
              // DOM
              var $this = $(this);
              // LOGIC
              var imageLink = $this.attr('data-src');

              if (typeof imageLink === 'string' && imageLink.trim().length !== 0) {
                $this.attr('src', imageLink);
              }
            });

            spinner.stop();

            loadAnimation
              .to($loader, 1, {
                opacity: 0,
                display: 'none',
                onComplete: function () {
                  $window.trigger('generic-preload-complete');

                  if (typeof $deeplinkSection !== 'undefined' && $deeplinkSection.length !== 0) {
                    $deeplinkSection.trigger('deeplink', { deeplinkData: deeplinkData });
                  }

                  $window.trigger('generic-boutique-scroll');
                  $window.trigger('generic-load-animation-complete');
                  $sections.filter('.active').trigger('gainedActive').trigger('gainedVisible');
                }
              });

            // MPP has no deeplink
            if (!$boutique.hasClass('mpp')) {
              loadAnimation.addCallback(function () {
                var scrollValue = 0;

                // Get target scroll value if a deep link section exists
                if (typeof $deeplinkSection !== 'undefined' && $deeplinkSection.length !== 0) {
                  $boutique.addClass('js-deeplinking');

                  // Get Deeplink scroll amount
                  // If the section content is larger than window, scroll to top
                  if ($deeplinkSection.height() > $window.height() || platformVars.isMobile) {
                    scrollValue = $deeplinkSection.offset().top - $('header').height() - (platformVars.isMobile ? $('#renutriv_nav', $boutique).height() : 0);
                    // Otherwise scroll so that the section content is in the middle of the page
                  } else {
                    scrollValue = $deeplinkSection.offset().top - ($window.height() - $deeplinkSection.height()) / 2 - $('header').height();
                  }

                  if ($deeplinkSection.is($boutique.find('section').first())) {
                    scrollValue = 0;
                  }
                }

                if (scrollValue !== 0) {
                  TweenMax.to($window, 1, {
                    scrollTo: {
                      y: scrollValue,
                      autoKill: false
                    },
                    onComplete: function () {
                      $window.trigger('generic-boutique-scroll');
                      $window.trigger('generic-load-animation-complete');
                      $boutique.removeClass('js-deeplinking');
                      $deeplinkSection.trigger('gainedActive').trigger('gainedVisible');
                    }
                  });
                }
              });
            }
          }
        });
      })();
      // ////////////////////////////////////////////////////////////////////////////////////
      // //////////// END: Preload Functionality
      // ////////////////////////////////////////////////////////////////////////////////////

      $boutique.trigger('generic-boutique-init', genericBoutique);
    }
  };
})(jQuery);
